export function calculatePricePerWeek(loanAmount, apr, term) {
    term = term * 12;
    const monthlyInterestRate = apr / 100 / 12;

    const interestMonthly =
        (loanAmount *
            (monthlyInterestRate * Math.pow(1 + monthlyInterestRate, term))) /
        (Math.pow(1 + monthlyInterestRate, term) - 1);

    return (interestMonthly * 12) / 52;
}

export function calculateTotalInterest(loanAmount, apr, term) {
    term = term * 12;
    const monthlyInterestRate = apr / 100 / 12;

    const interestMonthly =
        (loanAmount *
            (monthlyInterestRate * Math.pow(1 + monthlyInterestRate, term))) /
        (Math.pow(1 + monthlyInterestRate, term) - 1);

    return interestMonthly * term - loanAmount;
}
